import { render } from "./MobileAccountSubpage.vue?vue&type=template&id=74ff5097&scoped=true"
import script from "./MobileAccountSubpage.vue?vue&type=script&lang=js"
export * from "./MobileAccountSubpage.vue?vue&type=script&lang=js"

import "./MobileAccountSubpage.vue?vue&type=style&index=0&id=74ff5097&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ff5097"]])

export default __exports__